import { Box, Button, Icon, Theme } from "@outschool/backpack";
import { faBellConcierge } from "@outschool/icons";
import { useTranslation } from "@outschool/localization";
import { useTrackEvent } from "@outschool/ui-analytics";
import { useConcierge } from "@outschool/ui-components-website/src";
import { useIsMobile } from "@outschool/ui-utils";
import React from "react";

import { ConciergeNavItemContainer } from "../nav/ConciergeNavItem";

export function GetClassRecommendationsChatButton() {
  const { t } = useTranslation(
    "client\\components\\search\\GetClassRecommendations"
  );
  const isMobile = useIsMobile();
  const { canAccessConcierge } = useConcierge();

  const trackEvent = useTrackEvent();

  const handleButtonClick = () => {
    trackEvent("concierge_search_page_button_clicked", {
      can_access_concierge: canAccessConcierge
    });
  };

  return !isMobile ? (
    <Box
      sx={(theme: Theme) => ({
        position: "sticky",
        // place above logged-in footer on mobile
        bottom: "95px",
        marginTop: "1em",
        marginX: "auto",
        width: "95vw",
        [theme.breakpoints.up("sm")]: {
          bottom: "40px",
          width: "400px",
          marginTop: 0
        }
      })}
    >
      <ConciergeNavItemContainer>
        {({ onClick }) => (
          <Button
            variant="contained"
            size="large"
            startIcon={<Icon icon={faBellConcierge} />}
            sx={{
              width: "100%"
            }}
            onClick={() => {
              handleButtonClick();
              onClick();
            }}
          >
            {canAccessConcierge
              ? t("Get Class Recommendations")
              : t("Join to Access Concierge")}
          </Button>
        )}
      </ConciergeNavItemContainer>
    </Box>
  ) : (
    <></>
  );
}
